const InputText = (props) => {

    const handleInputChange = (event) => {
        let newValue = event.target.value;
        const MainName = event.target.name;

        if (newValue.startsWith(" ")) {
            newValue = newValue.trimStart();
        }

        const validInput = /^\d*$/;
        if (props.isNumber) {
            if (!validInput.test(newValue)) {
                return;
            }
            const sanitizedValue = newValue.match(/^-?\d*/)[0];
            newValue = sanitizedValue;

            if (props.onChange) {
                props.onChange({ ...event, target: { ...event.target, value: newValue, name: MainName } });
            }
        } else {

            if (props.onChange) {
                props.onChange({ ...event, target: { ...event.target, value: newValue, name: MainName } });
            }
        }
    }

    return (
        <label className={`w-[${props.width || "100%"}] inputBlock`}>
            <input
                type="text"
                value={props?.value}
                id={props?.id}
                onChange={(e) => handleInputChange(e)}
                spellCheck={false}
                className={`w-full h-[46px] ${props?.value?.length === 0 && props?.error ? "border-red-600 border-opacity-50" : "border-[#E5E7EB] focus:border-[1px] focus:border-[#0f0f0f]"} border-[1px] bg-white rounded-[8px] px-[10px] text-dark text-[15px] font-medium leading-[18.15px] focus:outline-none hover:shadow-custom-box-shadow transition duration-300`}
                autoComplete="on"
            />
        </label>
    )
}

export default InputText
